<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期间</label>
            <span class="weui-form-preview__value">{{initData.vm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <span class="weui-form-preview__value">{{initData.ve_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value">{{initData.ve_buyername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.vm_currency}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期初</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_begin}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期增加</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_add}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <em class="weui-form-preview__value">本期减少</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_reduce_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退票</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_reduce_back}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期末</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.vm_end}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>